// @flow

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import config from '../../../config/app.config.js';
import { useQuery } from '../../../modules/shared';
import type { RootState } from '../../../store/types';
import { getCookie } from '../../../utils/CommonUtils';

import { WS_GET_USER_DATA_FROM_FC_REQUEST } from '../../../store/actions';

export const DataCallback = () => {
  const history = useHistory();
  const query = useQuery();
  const dispatch = useDispatch();
  const franceConnect = useSelector((state: RootState) => state.franceConnect);
  const jwt =
    useSelector((state: RootState) => state.common.jwt) || getCookie(config.nameCookieJWT);

  useEffect(() => {
    if (query.get('code')) {
      const params = {
        grant_type: 'authorization_code',
        redirect_uri: `${config.siteURL}/data-callback`,
        client_id: config.franceConnect.clientId,
        code: query.get('code'),
        jwt,
      };

      // On fait un call vers l'Api en envoyant le code retourné par FC. Les datas utilisateurs sont récupérées par l'API et nous sont renvoyées.
      // Dans franceConnectEpic on vient dispatch le WS_GET_USER_DATA_FROM_FC_SUCCESS et stocker les infos utilisateurs dans le store (franceConnect.user)
      dispatch({ type: WS_GET_USER_DATA_FROM_FC_REQUEST, payload: { params } });
    }
  }, []);

  // If we have franceConnect infos, it means we should redirect to step2b
  useEffect(() => {
    if (franceConnect && franceConnect.user) {
      history.replace('/step2/2');
    }
  }, [franceConnect.user]);

  return null;
};
